// 统一的 postMessage 信任判定 —— widget 收到的**每一条**跨窗 postMessage 都该过这里。
// spec: docs/superpowers/specs/2026-08-07-native-chat-ui-design.md「Embed 交互 Bridge」红线 3。
//
// 背景:chat.js 的 APPLY_APP_CONFIG 分支此前无任何 origin/source 校验,同页任意脚本
// 或被嵌入的第三方内容都能伪造一帧改配色/文案/开关。embed bridge 正好逼出这层统一
// 安全原语:两端(宿主帧 / embed iframe)都用同一套「source 强绑定 + origin 白名单」。
//
// 不可伪造性:event.source 是发帧那个 window 的引用,浏览器填,脚本无法伪造。只要
// source === 我们期望的那个 window(外层 widget 的 window.parent / 某 iframe 的
// contentWindow),就锁死了对端身份;origin 白名单作纵深防御。
//
// 纯函数,零依赖,便于 node --test。

/**
 * @param {MessageEvent} event                     window 'message' 事件
 * @param {object}       opts
 * @param {Window}       opts.expectedSource        期望的发帧 window(必须严格 === )
 * @param {Set<string>|Array<string>} opts.allowedOrigins  允许的 origin 集合
 * @returns {boolean}
 */
export function isTrustedPostMessage(event, opts = {}) {
    if (!event) return false;
    const { expectedSource } = opts;
    // source 强绑定:给了 expectedSource 就必须严格相等(不可伪造)。
    // 注:某些同窗自发场景 event.source 可能为 null,此时只能退回 origin 校验——
    // 由调用方决定是否传 expectedSource(传了就强校验)。
    if (expectedSource !== undefined && expectedSource !== null) {
        if (!event.source || event.source !== expectedSource) return false;
    }
    const allowed = opts.allowedOrigins instanceof Set
        ? opts.allowedOrigins
        : new Set(Array.isArray(opts.allowedOrigins) ? opts.allowedOrigins : []);
    return allowed.has(event.origin);
}

/**
 * 组装 widget 允许的宿主 origin 集合:本源 + laneChatAllowedOrigins + server url origin。
 * 与 widget.js getAllowedOrigins 同源同义,抽出来给 chat.js(iframe 侧)复用。
 * @param {Window} win
 * @returns {Set<string>}
 */
export function collectAllowedHostOrigins(win) {
    const w = win || (typeof window !== 'undefined' ? window : null);
    const set = new Set();
    if (!w) return set;
    if (w.location && w.location.origin) set.add(w.location.origin);
    if (Array.isArray(w.laneChatAllowedOrigins)) {
        w.laneChatAllowedOrigins.forEach((o) => { if (o) set.add(o); });
    }
    if (w.laneChatServerUrl) {
        try { set.add(new URL(w.laneChatServerUrl).origin); } catch (e) { /* ignore */ }
    }
    return set;
}
